/* eslint-disable no-undef */
import React from 'react'
import { connect } from 'react-redux';
import { v4 } from 'uuid';
import { formatSeconds, getIcon, toMoney } from '../../Components/Functions';
import { routers } from '../../Constants/routers';

const RelatedSpecialists = ({ profile }) => {
    React.useEffect(() => {
        if(profile.related_specialists){
            setTimeout(() => {
                try {
                    initMoreListings();
                } catch (error) {
                    
                }
            }, 2000);
        }
    }, [profile])
    return (
        <div className="more-listings">
      {/*Title*/}
      <h4 className="title is-5">Related Specialists</h4>
      {/*Scheduled events carousel*/}
      <div className="scheduled-listings" 
        // data-x-data="initMoreListings()"
      >
        <div className="scheduled-listings-inner glide more-events-glide">
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              {
                  (profile.related_specialists || []).map((e) => {
                      return (
                        <li key={v4()} className="glide__slide"
                            
                            style={{ cursor: "pointer" }}
                        >
                        <a href={routers.pages.doctor(e.username)}
                             className="scheduled-listing">
                          <div className="scheduled-listing-image" 
                            style={{
                                background: `url("${
                                    e?.image || 
                                    (e?.gender === "MALE"
                                        ? require("../../assets/images/doctor-placeholder-male.jpg")
                                                .default
                                        : require("../../assets/images/doctor-placeholder-female.jpg")
                                                .default
                                    )}")`,
                                backgroundRepeat: "round"
                            }}
                          >
                            <div className="action-bar">
                              <button className="button wishlist-button"><i dangerouslySetInnerHTML={{ __html: getIcon("heart") }} /></button>
                            </div>
                          </div>
                          <div className="scheduled-listing-content"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden"
                            }}
                          >
                            <div className="scheduled-listing-rating">
                              <i dangerouslySetInnerHTML={{ __html: getIcon("star") }} />
                              <span>{e.rating}</span>
                              <span className="px-2">·</span>
                              <span>{e?.address_lga ? `${e?.address_lga},` : ''} {e?.address_state}</span>
                              
                            </div>
                            <p className="listing-name"><a>{e.title ? `${e.title} ` : ''}{e.name}</a></p>
                            <p className="listing-price">{toMoney(e.consultation_fee)} per <small>{formatSeconds(e.consultation_fee_duration)}</small></p>
                          </div>
                        </a>
                      </li>
                      )
                  })
              }
            </ul>
          </div>
          <div className="glide__arrows" data-glide-el="controls">
            <button className="glide__arrow glide__arrow--left" data-glide-dir="<">
              <i data-feather="arrow-left" />
            </button>
            <button className="glide__arrow glide__arrow--right" data-glide-dir=">">
              <i data-feather="arrow-right" />
            </button>
          </div>
        </div>
      </div>
    </div>
    )
}





const mapStateToProps = ({ specialist }) => ({ profile: specialist?.profile || [] });

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RelatedSpecialists);